var Curriculog = Curriculog || {};

Curriculog.HierarchyListView = (function ($, _, Backbone, HierarchyListView) {

	HierarchyListView = Curriculog.CurriculogView.extend({
		events: {
			'click .toggle-sublist': 'toggleSublist'
		},

		toggleSublist: function (event) {
			event.stopPropagation();
			if (this.$('ul:first').hasClass('expand')) {
				this.$('ul:first').removeClass('expand');
				this.$('.toggle-sublist:first').removeClass('contract-widget').addClass('expand-widget');
			} else {
				this.$('ul:first').addClass('expand');
				this.$('.toggle-sublist:first').removeClass('expand-widget').addClass('contract-widget');
			}
			hierarchyObject.verticalStretch();
		}
	});
	return HierarchyListView;

})($, _, Backbone, Curriculog.HierarchyListView || {});
